<template>
	<div class="o-grid">
		<p class="o-grid__item" v-if="error">{{ error }}</p>

		<v-runtime-template
			:template="searchResult"
			v-else-if="searchResult.length"
		></v-runtime-template>

		<!-- <div class="c-axiell-entry o-grid__item">
			<axiell-carousel class="c-axiell-entry__carousel" images="['PF53079', 'PF1087808']"></axiell-carousel>
			<header class="c-axiell-entry__header">
				<div>
					<a href="/search-our-collections" class="c-page-header__pretitle c-page-header__pretitle--link"> Back to search </a>
					<h1 class="c-axiell-entry__title"> Example title </h1>
					<dl class="c-axiell-entry__details">
						<div class="c-axiell-entry__details-item">
							<dt>
								Date:
							</dt>
							<dd>
								1815-1829
							</dd>
						</div>
					</dl>
				</div>
			</header>
			
			<div class="c-axiell-entry__description o-text">
				<p>
					Highland dirk with a broadbacked blade and a wooden hilt, second half of the 17th century
				</p>
			</div>

			<dl class="c-axiell-entry__meta c-description-list c-description-list--axiell">
				<dt class="c-description-list__key">
					Museum reference
				</dt>
				<dd class="c-description-list__value">
					H.LC 15
				</dd>
				<dt class="c-description-list__key">
					Materials
				</dt>
				<dd class="c-description-list__value">
					Wood, Iron
				</dd>
			</dl>

			<section class="c-axiell-entry__display c-axiell-display">
				<h2 class="c-axiell-display__title">This item is on display</h2>
				<p>
					> national museum of scotland<br>
					> level 1<br>
					> scotland galleries<br>
					> kingdom of the scots<br>
					> na gaidheil
				</p>
				<a class="c-axiell-display__action o-button o-button--secondary" href="#">View museum map</a>
			</section>
		</div> -->
	</div>
</template>

<script>
	import axios from "axios";
	import axiellCarousel from "./axiell-carousel.vue";
	import vRuntimeTemplate from "vue3-runtime-template";

	export default {
		data() {
			return {
				loading: true,
				entryID: null,
				error: null, //error string
				searchResult: "", //array of search results
			};
		},
		props:['apiUrl'],
		mounted() {
			const self = this;

			self.readQueryParam();

			// axios
			// 	.get(self.apiUrl + "/example.json")
			// 	.then((response) => {
			// 		console.log(response);

			// 		self.searchResult = response.data.html;
			// 	})
			// 	.catch((error) => {
			// 		console.log(error);

			// 		return "Error";
			// 	});
		},
		methods: {
			buildQuery() {
				const self = this;

				return (
					self.apiUrl +
					`/api/axiell?database=ChoiceCollect&search=priref=${self.entryID}&limit=1`
				);
			},
			getImage(id) {
				const self = this;

				if (id) {
					return (
						self.apiUrl +
						`/api/axiell?command=getcontent&server=Detail&width=310&height=285&scalemode=fill&imageformat=png&canvascolor=transparent&value=${id}`
					);
				} else {
					return;
				}
			},
			getData() {
				const self = this;

				axios({
						method: 'GET',
						url: self.buildQuery(),
						timeout: 30000, //30 second timeout for requests
						signal: AbortSignal.timeout(30000), //30 second timeout for connections
					})
					.then((response) => {
						console.log(response.data);

						self.searchResult = 
							response.data
								.replace(/<html>|<body>|<!DOCTYPE HTML>|<\/html>|<\/body>/g, '')
								.replace('collectionItem', 'c-axiell-entry o-grid__item')
								.replace('itemImages', 'c-axiell-entry__carousel')
								.replace('itemContent', 'c-axiell-entry__content')
								.replace('itemStructuredData', 'c-axiell-entry__structured-data')
								.replace('data-sc-history-back=""', '@click="historyBack"')
								.replace('data-museum-site="', '@click="museumLink" data-museum-site="');
					})
					.catch((error) => {
						console.log(error);

						if (error.code == "ECONNABORTED") {
							self.error = "That request has timed out, please try again later"
						} else {
							self.error = "An issue has occurred, please try again later"
						}

					});
			},
			search() {
				this.getData();
			},
			readQueryParam() {
				const self = this;
				const searchParams = new URLSearchParams(window.location.search);

				if (searchParams.get("entry")) {
					self.entryID = searchParams.get("entry");
					self.search();
				}
			},
			historyBack(event) {
				event.preventDefault();
				history.back();
			},
			museumLink(event) {
				event.preventDefault();
				
				let museumName = event.target.dataset.museumSite;

				switch (museumName) {
					case 'National Museum of Scotland':
						window.location.href = "https://www.nms.ac.uk/national-museum-of-scotland/plan-your-visit/museum-map";
						break;

					case 'National War Museum':
						window.location.href = "https://www.nms.ac.uk/national-war-museum/plan-your-visit/museum-map";
						break;

					case 'National Museum of Flight':
						window.location.href = "https://www.nms.ac.uk/national-museum-of-flight/plan-your-visit/museum-map";
						break;

					case 'National Museum of Rural Life':
						window.location.href = "https://www.nms.ac.uk/national-museum-of-rural-life/plan-your-visit/museum-map";
						break;
				
					default:
						break;
				}
			}
		},
		components: {
			axiellCarousel,
			vRuntimeTemplate
		},
	};
</script>
